"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Page;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PageModule = _interopRequireDefault(require("./Page.module.scss"));

var _Entry = _interopRequireDefault(require("./components/Entry/Entry"));

var _ClassSkill = _interopRequireDefault(require("../../../../../entities/skills/ClassSkill/ClassSkill"));

var _CraftingSkill = _interopRequireDefault(require("../../../../../entities/skills/CraftingSkill/CraftingSkill"));

var _ClassSkillCombo = _interopRequireDefault(require("../../../../../entities/skills/ClassSkillCombo/ClassSkillCombo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
TODOS:
- clicking a non-bought skill, focuses this skill
- clicking a bought skill, will activate dragmode (skill follows mouse)
- right clicking a bought skill, will trigger this skill
*/
function Page(_ref) {
  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      entityType = _ref.entityType,
      viewingCharacter = _ref.viewingCharacter,
      focusedPos = _ref.focusedPos,
      onClickEntry = _ref.onClickEntry,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  if (entries.length > 12) {
    throw new Error("Can only render 12 entries at max.");
  }

  var handleOnClickEntry = (0, _react.useCallback)(function (posX, posY) {
    if (onClickEntry) onClickEntry(posX, posY);
  }, [onClickEntry]);
  var renderEntry = (0, _react.useCallback)(function (entry) {
    var id = entry.id,
        x = entry.windowPosX,
        y = entry.windowPosY,
        level = entry.level,
        expPerc = entry.expPerc;

    if (x > 2 || y > 6) {
      throw new Error("Skill/Combo '".concat(id, "' can not be rendered due to wrong windowPos ").concat(x, "x").concat(y, "."));
    }

    var isFocused = x === (focusedPos === null || focusedPos === void 0 ? void 0 : focusedPos.x) && y === (focusedPos === null || focusedPos === void 0 ? void 0 : focusedPos.y);
    var isCombo = entityType === "COMBOS";
    var isComboUsable = isCombo && entry.model.isEnabled;
    var key = "entry".concat(x, "x").concat(y);

    var entryComponent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);

    switch (entityType) {
      case "CLASS":
        entryComponent = /*#__PURE__*/_react.default.createElement(_ClassSkill.default, {
          skill: entry,
          viewingCharacter: viewingCharacter
        });
        break;

      case "COMBOS":
        entryComponent = /*#__PURE__*/_react.default.createElement(_ClassSkillCombo.default, {
          skillCombo: entry,
          viewingCharacter: viewingCharacter
        });
        break;

      case "CRAFTING":
        entryComponent = /*#__PURE__*/_react.default.createElement(_CraftingSkill.default, {
          skill: entry
        });
        break;

      default:
        throw new Error("Unknown entityType '".concat(JSON.stringify(entityType), "'"));
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      key: key,
      onClick: function onClick() {
        handleOnClickEntry(x, y);
      },
      className: (0, _classnames.default)(_PageModule.default.entry, _PageModule.default[key])
    }, /*#__PURE__*/_react.default.createElement(_Entry.default, {
      entryComponent: entryComponent,
      level: level,
      expPerc: expPerc,
      isFocused: isFocused,
      isCombo: isCombo,
      isComboUsable: isComboUsable
    }));
  }, [focusedPos, entityType, viewingCharacter, handleOnClickEntry]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_PageModule.default.page, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, entries.map(function (entry) {
    return renderEntry(entry);
  })));
}